import { Typography, useTheme } from '@mui/material'
import { FlexBoxProps, FlexCol, FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'

import ComponentSize from '../../ComponentSize'
import { AuctionCard } from '../Auction'

interface Props extends FlexBoxProps {
  hideQuadkey?: boolean
  hideTitle?: boolean
  hideValue?: boolean
  orientation?: 'vertical' | 'horizontal'
  page?: string
  quadkey?: Quadkey
  size?: ComponentSize
  spacing?: number
}

const Children: React.FC<Props> = ({
  hideValue,
  hideQuadkey,
  hideTitle,
  quadkey,
  page = 'auction',
  size = 'medium',
  orientation = 'horizontal',
  spacing = 1,
  ...props
}) => {
  const quadkeys = quadkey?.children()
  const theme = useTheme()
  if (quadkeys && quadkeys.length === 4) {
    return (
      <FlexCol alignItems="stretch" {...props}>
        {!hideTitle ? (
          <FlexRow borderBottom={`solid 1px ${theme.palette.divider}`}>
            <Typography variant="caption">Children</Typography>
          </FlexRow>
        ) : null}
        <FlexRow flexWrap="wrap" flexDirection={orientation === 'vertical' ? 'column' : 'row'}>
          <FlexRow>
            <AuctionCard hideQuadkey={hideQuadkey} hideValue={hideValue} page={page} quadkey={quadkeys[0]} size={size} margin={spacing} />
            <AuctionCard hideQuadkey={hideQuadkey} hideValue={hideValue} page={page} quadkey={quadkeys[1]} size={size} margin={spacing} />
          </FlexRow>
          <FlexRow>
            <AuctionCard hideQuadkey={hideQuadkey} hideValue={hideValue} page={page} quadkey={quadkeys[2]} size={size} margin={spacing} />
            <AuctionCard hideQuadkey={hideQuadkey} hideValue={hideValue} page={page} quadkey={quadkeys[3]} size={size} margin={spacing} />
          </FlexRow>
        </FlexRow>
      </FlexCol>
    )
  } else {
    return null
  }
}

export default Children
